export default "__VITE_ASSET__DkGcflWf__"